module.exports = __webpack_public_path__ + "static/media/car.2198a2f5.svg";